<!DOCTYPE html>
<template>
<div class="home">

  <b-jumbotron header="Vetted Cyber Talent"
               text-variant="white"
               bg-variant="primary"
               lead="Cybersecurity professionals. On demand. For fintech and digital health.">


    <b-button variant="success shadow-lg"
              @click="getStarted"
              size="lg">Start Your Project</b-button>


    <a href="https://www.producthunt.com/posts/blue-team?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-blue-team"
    target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=189557&theme=light"
    alt="Blue Team - Cybersecurity talent. On Demand. For FinTech & MedTech. | Product Hunt Embed"
    style="width: 250px; height: 54px; padding: 3px;" width="250px" height="54px" /></a>


  </b-jumbotron>

  <a class="anchor"
     id="onboarding"></a>

  <div class="onboarding"
       v-if="!user">


    <OnboardCard v-show="showClients"
                 type="client"
                 :enlarged="enlarged"
                 @started="startedQuestionnaire($event)" />

    <OnboardCard v-show="showProviders"
                 type="provider"
                 :enlarged="enlarged"
                 @started="startedQuestionnaire($event)" />

  </div>

  <div class="marketing"
       v-if="!onboarding">


    <div class="more providers">
      <img class="illustration"
           src="@/assets/Provider.png" />
      <div>
        <h2>Built by Security Pros for Security Pros</h2>
        <p>
          You take your job seriously. And so do we.
          BlueTeam takes care of finding you jobs, dealing with contracts,
          and following up on invoices — so you can focus on the client's security.

        </p>
        <b-button variant="success"
                  @click="startedQuestionnaire('provider')">Try it now</b-button>
      </div>
    </div>

    <div class="more clients">
      <div>
        <h2>Clients love BlueTeam</h2>
        <p>
          Connect with our growing network of vetted professionals, and
          seamlessly onboard experienced specialists.
        </p>
        <p>
        Our transparent pricing and easy to use payments system makes accessing the best
        cyber talent easier than ever.
        </p>
        <b-button variant="success"
                  @click="startedQuestionnaire('client')">Try for free</b-button>
      </div>
      <img class="illustration"
           src="@/assets/Client.png" />
    </div>

    <b-container class="more social-proof">
      <h2>See what others are saying</h2>
      <div class="items">
        <b-card class="shadow-lg p-4">
          "Without BlueTeam, we would have had to screen dozens of candidates to perform the variety of challenges holding us back."
        </b-card>
        <b-card class="shadow-lg p-4">
          "We needed to get our cybersecurity under control fast. BlueTeam made it quick and simple to find high-quality talent."
        </b-card>
      </div>
    </b-container>

    <div class="more partnerships">
      <h2>Some of our partners</h2>
      <div class="partners">
        <b-card class="shadow-lg">
          <img src="@/assets/attune.png" style="width:120px">
        </b-card>
        <b-card class="shadow-lg">
            <img src="@/assets/ticketech.png" style="width:120px">
        </b-card>
        <b-card class="shadow-lg">
          <img src="@/assets/grasshopper.png" style="width:120px">
        </b-card>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import OnboardCard from '@/components/OnboardCard.vue'
export default {
  name: 'Home',
  components: {
    OnboardCard,
  },
  metaInfo () {
    return {
      title: 'Home',
      meta: [
        { name: "description", content: "Home" },
        { name: "twitter:title", content: "BlueTeam", vmid: 'twitter:title' },
        { name: "og:image", content: "https://getblueteam.com/img/BlueTeamLogo.bb7395fa.png" },
        { name: "twitter:description", content: 'Vetted cybersecurity talent for Fintech & Digital Health', vmid: 'twitter:description' },
        { name: "keywords", content: "cybersecurity, talent, fintech, digital health, appsec, IAM, identity management, devsecops, devops, cloud security" }
      ]
    }
  },
  watch: {},
  mounted() {
    window.addEventListener( 'scroll', this.onScroll )
  },
  beforeDestroy() {
    window.removeEventListener( 'scroll', this.onScroll )
  },
  data() {
    return {
      questionnaire: null,
      onboarding: false,
    }
  },
  props: {
    user: Object
  },
  computed: {
    showClients() {
      return !this.questionnaire || this.questionnaire == 'client' ? true : false
    },
    showProviders() {
      return !this.questionnaire || this.questionnaire == 'provider' ? true : false
    },
    enlarged() {
      return this.questionnaire ? true : false
    }
  },
  methods: {
    startedQuestionnaire( type ) {
      this.questionnaire = type
      if ( type ) {
        this.onboarding = true
        var e = document.getElementById( 'onboarding' );
        e.scrollIntoView()
      } else {
        this.onboarding = false
        window.scrollTo( 0, 0 )
      }
    },
    getStarted() {
      window.location.hash = ''
      window.location.hash = 'onboarding'
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/styles/global.scss";

.home {
    display: grid;
    grid-row-gap: 0rem;
    max-width: 1200px;
    min-height: 100vh;
    margin: 0 auto;
    align-items: flex-start;
    align-content: flex-start;
    color: $primary;

    .anchor {
      padding-top: 8rem;
      margin-top: -8rem;
    }

    .onboarding {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        grid-column-gap: 1rem;
    }

    .marketing {
        display: grid;
        grid-row-gap: 4rem;

        .more {
            grid-template-columns: 2fr 3fr;
            display: grid;
            grid-column-gap: 4rem;
            padding: 4rem;

            div {
                display: grid;
                grid-row-gap: 1rem;
                justify-items: flex-start;
            }

            img {
                width: 100%;
            }

            h2 {
                font-size: 3rem;
                color: theme-color-level('primary',5);
            }
            p {
                font-size: 1.2rem;
                color: theme-color-level('primary',0);
            }
        }

        .partnerships {
            background: theme-color-level('warning', -12);
            border-radius: 2rem;

            .partners {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));

                > div {
                    min-width: 10rem;
                    align-items: center;
                    color: theme-color-level('primary', 5);
                }
            }
        }

        .social-proof {

            .items {
                display: grid;
                grid-auto-flow: row;
                grid-auto-columns: 1fr;
                grid-column-gap: 3rem;
                font-size: 1.2rem;

                color: theme-color-level('primary',5);
            }
        }

    }
}
</style>
